import { render, staticRenderFns } from "./matching-card-options.vue?vue&type=template&id=890bd84e&scoped=true&"
import script from "./matching-card-options.vue?vue&type=script&lang=ts&"
export * from "./matching-card-options.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-options.vue?vue&type=style&index=0&id=890bd84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890bd84e",
  null
  
)

export default component.exports